var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-form",
        {
          ref: "detailForm",
          staticClass: "el-form-flex",
          attrs: {
            disabled: _vm.action === "view",
            model: _vm.supplierInfo,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-collapse",
            {
              staticClass: "el-card-collapse",
              model: {
                value: _vm.activeCollapses,
                callback: function ($$v) {
                  _vm.activeCollapses = $$v
                },
                expression: "activeCollapses",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "基本信息", name: "Basic" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { sm: 24, md: 12, lg: 10 } }, [
                        _c(
                          "div",
                          { staticClass: "el-form-content" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "经营类型",
                                  prop: "workingGroup",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "max-width",
                                    model: {
                                      value:
                                        _vm.supplierInfo.detail.workingGroup,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.detail,
                                          "workingGroup",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "supplierInfo.detail.workingGroup",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: 12, label: "普通商户" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "商户类型",
                                  prop: "merchantType",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "max-width",
                                    model: {
                                      value:
                                        _vm.supplierInfo.detail.merchantType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.detail,
                                          "merchantType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "supplierInfo.detail.merchantType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: 1, label: "企业商户" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: 2, label: "个体工商户" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "推荐人邀请码",
                                  prop: "inviteCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "max-width",
                                  attrs: { placeholder: "请输入推荐人邀请码" },
                                  model: {
                                    value: _vm.supplierInfo.inviteCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplierInfo,
                                        "inviteCode",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "supplierInfo.inviteCode",
                                  },
                                }),
                                _vm.supplierInfo.inviterName
                                  ? _c("span", { staticClass: "pl-10" }, [
                                      _vm._v(
                                        _vm._s(_vm.supplierInfo.inviterName)
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "商户全称", prop: "shopName" },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入营业执照上的全称",
                                  },
                                  model: {
                                    value: _vm.supplierInfo.shopName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplierInfo,
                                        "shopName",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "supplierInfo.shopName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "商户简称", prop: "shortName" },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "将在支付完成页面向消费者展示",
                                  },
                                  model: {
                                    value: _vm.supplierInfo.shortName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplierInfo,
                                        "shortName",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "supplierInfo.shortName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "营业执照编号",
                                  prop: "detail.licenceNo",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入统一社会信用代码",
                                  },
                                  model: {
                                    value: _vm.supplierInfo.detail.licenceNo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplierInfo.detail,
                                        "licenceNo",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "supplierInfo.detail.licenceNo",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "执照有效期类型" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    staticClass: "max-width",
                                    model: {
                                      value:
                                        _vm.supplierInfo.detail.licenseDateType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.detail,
                                          "licenseDateType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "supplierInfo.detail.licenseDateType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("非长期"),
                                    ]),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("长期"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.supplierInfo.detail.licenseDateType === 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "营业执照有效期",
                                      prop: "detail.licenseDate",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      key: "licenseDateType1",
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        format: "yyyy-MM-dd",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value:
                                          _vm.supplierInfo.detail.licenseDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.supplierInfo.detail,
                                            "licenseDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "supplierInfo.detail.licenseDate",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "营业执照有效期",
                                      prop: "detail.licenseStart",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      key: "licenseDateType2",
                                      staticClass: "max-width",
                                      attrs: {
                                        type: "date",
                                        placeholder: "开始日期",
                                        format: "yyyy-MM-dd",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value:
                                          _vm.supplierInfo.detail.licenseStart,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.supplierInfo.detail,
                                            "licenseStart",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "supplierInfo.detail.licenseStart",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "所在区域",
                                  prop: "regionInfo",
                                },
                              },
                              [
                                _vm.showRegion
                                  ? _c("el-cascader", {
                                      ref: "regionCascader",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        props: {
                                          value: "regionCode",
                                          label: "regionName",
                                        },
                                        options: _vm.regionOptions,
                                        placeholder: "请选择所在区域",
                                        clearable: "",
                                      },
                                      on: { change: _vm.regionChange },
                                      model: {
                                        value: _vm.supplierInfo.regionInfo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.supplierInfo,
                                            "regionInfo",
                                            $$v
                                          )
                                        },
                                        expression: "supplierInfo.regionInfo",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "详细地址", prop: "address" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入详细地址" },
                                  model: {
                                    value: _vm.supplierInfo.address,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplierInfo,
                                        "address",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "supplierInfo.address",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "积分抵扣", prop: "discount" },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    staticClass: "max-width",
                                    attrs: {
                                      type: "number",
                                      min: "0",
                                      max: "30",
                                      placeholder: "请输入优惠折扣",
                                    },
                                    model: {
                                      value: _vm.supplierInfo.discount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo,
                                          "discount",
                                          $$v
                                        )
                                      },
                                      expression: "supplierInfo.discount",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "suffix" },
                                        slot: "suffix",
                                      },
                                      [_vm._v("%")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-col",
                        {
                          attrs: {
                            sm: 24,
                            md: 12,
                            lg: { span: 10, offset: 4 },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "el-form-content" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "登录手机号",
                                    prop: "mobile",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "max-width",
                                    attrs: {
                                      type: "number",
                                      placeholder: "请输入11位手机号码",
                                      oninput:
                                        "if(value.length>11)value=value.slice(0,11)",
                                    },
                                    model: {
                                      value: _vm.supplierInfo.mobile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo,
                                          "mobile",
                                          $$v
                                        )
                                      },
                                      expression: "supplierInfo.mobile",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.action === "create"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "登录密码",
                                        prop: "password",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "max-width",
                                        attrs: {
                                          "show-password": "",
                                          placeholder: "请输入登录密码",
                                        },
                                        model: {
                                          value: _vm.supplierInfo.password,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.supplierInfo,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "supplierInfo.password",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.action !== "create"
                                ? _c(
                                    "el-form-item",
                                    { attrs: { label: "平台商户编号" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: "",
                                          placeholder: "平台商户编号",
                                        },
                                        model: {
                                          value: _vm.supplierInfo.merchantId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.supplierInfo,
                                              "merchantId",
                                              $$v
                                            )
                                          },
                                          expression: "supplierInfo.merchantId",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人姓名",
                                    prop: "detail.legalName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入法人姓名" },
                                    model: {
                                      value: _vm.supplierInfo.detail.legalName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.detail,
                                          "legalName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "supplierInfo.detail.legalName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人身份证号码",
                                    prop: "detail.legalIdCard",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入法人身份证号码",
                                    },
                                    model: {
                                      value:
                                        _vm.supplierInfo.detail.legalIdCard,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.detail,
                                          "legalIdCard",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "supplierInfo.detail.legalIdCard",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "证件有效期类型" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "max-width",
                                      model: {
                                        value:
                                          _vm.supplierInfo.detail.cardDateType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.supplierInfo.detail,
                                            "cardDateType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "supplierInfo.detail.cardDateType",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("非长期"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("长期"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.supplierInfo.detail.cardDateType === 1
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "法人证件有效期",
                                        prop: "detail.cardDate",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        key: "cardDateType1",
                                        attrs: {
                                          type: "daterange",
                                          "range-separator": "至",
                                          "start-placeholder": "开始日期",
                                          "end-placeholder": "结束日期",
                                          format: "yyyy-MM-dd",
                                          "value-format": "yyyy-MM-dd",
                                        },
                                        model: {
                                          value:
                                            _vm.supplierInfo.detail.cardDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.supplierInfo.detail,
                                              "cardDate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "supplierInfo.detail.cardDate",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "法人证件有效期",
                                        prop: "detail.legalCardStart",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        key: "cardDateType2",
                                        staticClass: "max-width",
                                        attrs: {
                                          type: "date",
                                          placeholder: "开始日期",
                                          format: "yyyy-MM-dd",
                                          "value-format": "yyyy-MM-dd",
                                        },
                                        model: {
                                          value:
                                            _vm.supplierInfo.detail
                                              .legalCardStart,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.supplierInfo.detail,
                                              "legalCardStart",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "supplierInfo.detail.legalCardStart",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "营业时间",
                                    prop: "openHours",
                                  },
                                },
                                [
                                  _c("el-time-picker", {
                                    staticClass: "max-width",
                                    attrs: {
                                      format: "HH:mm",
                                      "value-format": "HH:mm",
                                      editable: false,
                                      placeholder: "开始时间",
                                    },
                                    model: {
                                      value: _vm.supplierInfo.openHours[0],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.openHours,
                                          0,
                                          $$v
                                        )
                                      },
                                      expression: "supplierInfo.openHours[0]",
                                    },
                                  }),
                                  _c("span", { staticClass: "ml-10 mr-10" }, [
                                    _vm._v("至"),
                                  ]),
                                  _c("el-time-picker", {
                                    staticClass: "max-width",
                                    attrs: {
                                      format: "HH:mm",
                                      "value-format": "HH:mm",
                                      editable: false,
                                      placeholder: "打烊时间",
                                    },
                                    model: {
                                      value: _vm.supplierInfo.openHours[1],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.openHours,
                                          1,
                                          $$v
                                        )
                                      },
                                      expression: "supplierInfo.openHours[1]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "门店电话", prop: "phone" } },
                                [
                                  _c("el-input", {
                                    staticClass: "max-width",
                                    attrs: {
                                      type: "number",
                                      placeholder: "请输入门店电话",
                                    },
                                    model: {
                                      value: _vm.supplierInfo.phone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.supplierInfo, "phone", $$v)
                                      },
                                      expression: "supplierInfo.phone",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "特色介绍", prop: "feature" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入特色介绍" },
                                    model: {
                                      value: _vm.supplierInfo.feature,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo,
                                          "feature",
                                          $$v
                                        )
                                      },
                                      expression: "supplierInfo.feature",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "资质编号",
                                    prop: "detail.qualification",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder:
                                        "请输入资质编号，如：粤卫食证字[2007]第0307A123456",
                                    },
                                    model: {
                                      value:
                                        _vm.supplierInfo.detail.qualification,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo.detail,
                                          "qualification",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "supplierInfo.detail.qualification",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "排序", prop: "sortBy" } },
                                [
                                  _c("el-input", {
                                    staticClass: "max-width",
                                    attrs: {
                                      type: "number",
                                      min: "0",
                                      placeholder: "请输入排列顺序",
                                    },
                                    model: {
                                      value: _vm.supplierInfo.sortBy,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.supplierInfo,
                                          "sortBy",
                                          $$v
                                        )
                                      },
                                      expression: "supplierInfo.sortBy",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "账户信息", name: "Bank" } },
                [
                  _c("detail-account", {
                    model: {
                      value: _vm.supplierInfo,
                      callback: function ($$v) {
                        _vm.supplierInfo = $$v
                      },
                      expression: "supplierInfo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "证件信息", name: "Photo" } },
                [
                  _c("detail-photo", {
                    attrs: {
                      detail: _vm.supplierInfo.detail,
                      disabled: _vm.action !== "view",
                    },
                    on: { preview: _vm.handlePreview },
                    model: {
                      value: _vm.images,
                      callback: function ($$v) {
                        _vm.images = $$v
                      },
                      expression: "images",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-image", {
            ref: "elImage",
            staticStyle: { width: "0", height: "0" },
            attrs: { src: _vm.previewImg, "preview-src-list": _vm.previewList },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "app-form-button-height" }),
      _c(
        "div",
        { staticClass: "app-form-button-group" },
        [
          _c(
            "el-button",
            { attrs: { icon: "el-icon-back" }, on: { click: _vm.onBack } },
            [_vm._v("返回列表")]
          ),
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.onCreate } },
            [_vm._v("新增供应商")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("提交保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }